import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { HTTP } from "../api/http-common";
import { useNavigate, Link } from "react-router-dom";
import Pagination from '../component/pagination';
import CouponList from './Admin/CouponList';
import CouponModal from '../component/CouponModal';
import { useGlobalContext } from "../component/GlobalContext";
import MemberList from "./Admin/MemberList";
import CategoryModal from "../component/CategoryModal";
import { PlusIcon, SearchIcon } from "lucide-react";

function MemberTable() {
  const { isAuthenticated } = useGlobalContext();
  const access_token = (localStorage.getItem('access_token'));
  const [coupons, setCoupons] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ page: '1', limit: '10' });
  const [search, setSearch] = useState({ search_value: '' });
  const [searchValue, setSearchValue] = useState('');
  const [role, setRole] = useState("");
  useEffect(() => {
    // console.log('here');
    if (isAuthenticated) {
      let userObj = localStorage.getItem('userObj');
      if (userObj != null && userObj !== "") {
        let userJson = JSON.parse(userObj);
        setRole(userJson.role.name)
      }
    }
  }, [isAuthenticated]);

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
  });


  const fetchTableData = async (couponData) => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {
      filters: {
        search_value: search.search_value,
        coupon_type: filterType
      },
      pagination: pagination,
      sorting: { field: 'id', type: 'desc' },
    };
    HTTP.post('user/member/list', fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setfilteredData(data.contents);
          setTotal(data.total_count);
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        setError(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };


  useEffect(() => {
    fetchTableData();
  }, [searchQuery, filterType, currentPage, pagination]); // Add coupons to the dependency array
  // }, [searchQuery, filterType,currentPage,pagination]);  // Add coupons to the dependency array

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const onSearchEnter = (value) => {
    if (value.length == 0 || value.length >= 3) {
      setSearch({ ...search, search_value: value });
      setPagination({ ...pagination, page: 1, limit: (pagination.limit) });
    }
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const convertToISODate = (dateString) => {
    const date = new Date(dateString); // Parse the input string into a Date object
    const year = date.getFullYear(); // Get the year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, pad to 2 digits
    const day = String(date.getDate()).padStart(2, '0'); // Pad day to 2 digits
    return `${year}-${month}-${day}`; // Format as Y-m-d
  };

  // if (loading) return <p>Loading coupons...</p>;
  if (error) return <p>{error}</p>;


  const onPaginationChange = (page) => {
    // alert('here')
    setPagination({ ...pagination, page });
  };
  const onLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPagination({ ...pagination, limit: newLimit, page: 1 });
  };


  return (
    <div className="admin-table-container container mx-auto">
      <div className="admin-table-header">
        <div className="flex items-center">
          <span className="w-4">
            <SearchIcon className="w-4" />
          </span>
          <input
            type="text"
            placeholder="Search "
            className="admin-table-search-input w-full"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { onSearchEnter(e.target.value) } }}
          />
        </div>
      </div>

      {/* Start to fetch the data */}
      <div className="custom-overflow-wrapper admin-table-custom-overflow-wrapper p-[20px] px-[17px] rounded-[12px] border border-gray-300 bg-[#ffffff] mb-3">
        <table className="admin-table-table">
          <thead>
            <tr>
              {/* <th className="admin-table-th">Id</th> */}
              <th className="admin-table-th">Name</th>
              <th className="admin-table-th">Email</th>
              <th className="admin-table-th">Plan Amount</th>
              <th className="admin-table-th">Plan Type</th>
              <th className="admin-table-th">Plan Start Date</th>
              <th className="admin-table-th">Plan Expiration Date</th>
              <th className="admin-table-th">Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(filteredData) && filteredData.length > 0 ? (
              filteredData.map((member) => (
                <MemberList key={member.id} member={member} fetchTableData={fetchTableData} />
              ))
            ) : (
              <tr>No data found</tr>
            )}
          </tbody>
        </table>
      </div>

      {Array.isArray(filteredData) && filteredData.length > 0 ? (
        <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
      ) : (
        null
      )}
    </div>
  );
}

export default MemberTable;
